import { useNavigate } from 'react-router';

import { Button } from '@data-products-and-ai/react-components';
import { OUTAGES_ROUTE } from '@/pages/Outages/routes';

import '@/pages/NotFound/styles.scss';

export const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(OUTAGES_ROUTE);
  };

  return (
    <div className="not-found-page">
      <img
        className="not-found-page__image"
        src="/images/page_not_found.png"
        alt="404"
      />
      <Button allCaps={false} type="primaryNoShadow" onClick={handleClick}>
        Go back to Home Page
      </Button>
    </div>
  );
};
